import React, { useContext } from 'react';
import {
  ToggleSwitch,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  ToggleSwitchOnLabel,
  ToggleSwitchOffLabel,
  TableCaption,
  H3,
  Typography,
} from '@vp/swan';
import { PageModsContext } from '../../contexts/PageModsContext';
import {
  ITEM_SCOPE,
  ITEM_GROUP_SCOPE,
  ORDER_SCOPE,
  PAGE_SCOPE,
} from '../../../constants/pageModScopes';
import { PageModEntry } from './PageModEntry';

export const PageModsDisplay = () => {
  const {
    pageLevelPageUxMods,
    setPageLevelPageUxMods,
    itemLevelPageUxMods,
    setItemLevelPageUxMods,
    orderLevelPageUxMods,
    setOrderLevelPageUxMods,
    itemGroupLevelPageUxMods,
    setItemGroupLevelPageUxMods,
  } = useContext(PageModsContext);

  const toggleModEnabled = modToToggle => {
    if (modToToggle.scope === ITEM_SCOPE) {
      // update item-level page mods
      const pageUxModsClone = [...itemLevelPageUxMods];
      const indexToToggle = pageUxModsClone.findIndex(
        mod => mod.modRef === modToToggle.modRef
      );
      pageUxModsClone[indexToToggle].enabled = !modToToggle.enabled;
      setItemLevelPageUxMods(pageUxModsClone);
    }

    if (modToToggle.scope === PAGE_SCOPE) {
      // update page-level page mods
      const pageUxModsClone = [...pageLevelPageUxMods];
      const indexToToggle = pageUxModsClone.findIndex(
        mod => mod.modRef === modToToggle.modRef
      );
      pageUxModsClone[indexToToggle].enabled = !modToToggle.enabled;
      setPageLevelPageUxMods(pageUxModsClone);
    }

    if (modToToggle.scope === ORDER_SCOPE) {
      // update page-level page mods
      const orderUxModsClone = [...orderLevelPageUxMods];
      const indexToToggle = orderUxModsClone.findIndex(
        mod => mod.modRef === modToToggle.modRef
      );
      orderUxModsClone[indexToToggle].enabled = !modToToggle.enabled;
      setOrderLevelPageUxMods(orderUxModsClone);
    }

    if (modToToggle.scope === ITEM_GROUP_SCOPE) {
      // update page-level page mods
      const itemGroupUxModsClone = [...itemGroupLevelPageUxMods];
      const indexToToggle = itemGroupUxModsClone.findIndex(
        mod => mod.modRef === modToToggle.modRef
      );
      itemGroupUxModsClone[indexToToggle].enabled = !modToToggle.enabled;
      setItemGroupLevelPageUxMods(itemGroupUxModsClone);
    }
  };

  return (
    <Table skin="dividers">
      <TableCaption>
        <H3 visuallyHidden>Page mods</H3>
      </TableCaption>
      <TableHead>
        <TableRow>
          <TableCell id="mod-family-label">Family</TableCell>
          <TableCell id="mod-id-label">ID</TableCell>
          <TableCell id="mod-scope-label">Scope</TableCell>
          <TableCell id="mod-enabled-label">Enabled</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {pageLevelPageUxMods
          .concat(itemLevelPageUxMods)
          .concat(orderLevelPageUxMods)
          .concat(itemGroupLevelPageUxMods)
          .map(pageUxMod => (
            <TableRow>
              <TableCell textAlign="left">
                <Typography fontSize="small">
                  {pageUxMod.modRef.family}
                </Typography>
              </TableCell>
              <TableCell textAlign="left">
                <Typography fontSize="small">{pageUxMod.modRef.id}</Typography>
              </TableCell>
              <TableCell textAlign="left">
                <Typography fontSize="small">{pageUxMod.scope}</Typography>
              </TableCell>
              <TableCell textAlign="left">
                <ToggleSwitch
                  activated={pageUxMod.enabled}
                  onRequestActivatedChange={() => toggleModEnabled(pageUxMod)}
                  hideText
                  aria-labelledby="mod-enabled-label"
                >
                  <ToggleSwitchOnLabel>Enabled</ToggleSwitchOnLabel>
                  <ToggleSwitchOffLabel>Disabled</ToggleSwitchOffLabel>
                </ToggleSwitch>
              </TableCell>
            </TableRow>
          ))}
        <PageModEntry />
      </TableBody>
    </Table>
  );
};
